import { useEffect } from "react";

interface SEOProps {
  title: string;
  description: string;
  canonical?: string;
  image?: string;
  schema?: Record<string, unknown>;
}

/**
 * Route-level `head()` metadata is the source of truth for public SEO.
 * This component only injects JSON-LD on the client as a fallback for
 * pages that still pass schema directly from their component tree.
 */
export const SEO = ({ schema }: SEOProps) => {
  useEffect(() => {
    setJsonLd(schema);
  }, [schema]);

  return null;
};

function setJsonLd(schema?: Record<string, unknown>) {
  const id = "seo-jsonld";
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  if (!schema) return;
  const s = document.createElement("script");
  s.type = "application/ld+json";
  s.id = id;
  s.text = JSON.stringify(schema);
  document.head.appendChild(s);
}
